import {v4 as uuidv4} from 'uuid'

export const projects = [
    {
        id: uuidv4(),
        title: "Tesla Clone",
        desc: "REACT . REDUX . HOOKS . MATERIAL UI . FIREBASE ",
        github: "https://github.com/pranavkhot/Tesla-Clone.git",
        demo: "https://tesla-clone-27feb.web.app",
        image: "./images/tesla.jpg",
    },
    {
        id: uuidv4(),
        title: "Banking App",
        desc: "REACT . HOOKS . SMOOTH SCROLL . MATERIAL UI . STYLED COMPONENTS ",
        github: "https://github.com/pranavkhot/BankingAppUI.git",
        demo: "https://chime45.netlify.app",
        image: "./images/bank.png",
    },
    {
        id: uuidv4(),
        title: "Starbucks Clone",
        desc: "REACT . REDUX . HOOKS . FRAMER MOTION . MATERIAL UI . HOOKS FORM . FIREBASE ",
        github: "https://github.com/pranavkhot/Starbucks-Clone.git",
        demo: "https://starbucks-clone-5aa8a.web.app/",
        image: "./images/starbucks.png",
    },
    {
        id: uuidv4(),
        title: "Covid Tracker",
        desc: "REACT . HOOKS . MATERIAL UI ",
        github: "https://github.com/pranavkhot/Covid-Tracker.git",
        demo: "https://covid-19-tracker-9a046.web.app",
        image: "./images/covid.png",
    },
    {
        id: uuidv4(),
        title: "ASAP Comparison",
        desc: "JAVASCRIPT . EJS . NODE JS . MONGODB",
        github: "https://github.com/ASAP6920/ASAP-COMPARISON.git",
        demo: "https://asapcomparison.live",
        image: "./images/asap-1.png",
    },
    {
        id: uuidv4(),
        title: "Crypto Tracker",
        desc: "NEXT . REACT . HOOKS . MATERIAL UI",
        github: "https://github.com/pranavkhot/CryptoTracker.git",
        demo: "https://cryptotracker-pi.vercel.app",
        image: "./images/crypto.jpg",
    },

]